import { render, staticRenderFns } from "./SortHeader.vue?vue&type=template&id=eb06945a&scoped=true&"
import script from "./SortHeader.vue?vue&type=script&lang=ts&"
export * from "./SortHeader.vue?vue&type=script&lang=ts&"
import style0 from "./SortHeader.vue?vue&type=style&index=0&id=eb06945a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb06945a",
  null
  
)

export default component.exports